import { render, staticRenderFns } from "./platformOfeditQuestionBank.vue?vue&type=template&id=66c4a408"
import script from "./platformOfeditQuestionBank.vue?vue&type=script&lang=js"
export * from "./platformOfeditQuestionBank.vue?vue&type=script&lang=js"
import style0 from "./platformOfeditQuestionBank.vue?vue&type=style&index=0&id=66c4a408&prod&lang=less"
import style1 from "./platformOfeditQuestionBank.vue?vue&type=style&index=1&id=66c4a408&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports